import { combineReducers } from 'redux'
import authReducer from './authReducer.js'
import fetchReducer from './fetchReducer.js'
import configReducer from './configReducer.js'

export default combineReducers({
    auth: authReducer,
    fetch: fetchReducer,
    config: configReducer
});